<!-- Backgroud Parallax -->
<img fxHide.xs appParallax [ratio]="0.2" class="background-circular" src="/assets/img/background-circular.svg" alt="Background Circular" />

<!-- Backgroud Parallax Mobile -->
<img fxHide fxShow.xs appParallax [ratio]="0.14" class="background-circular" src="/assets/img/background-circular-mobile.svg" alt="Background Circular" />


<app-navbar></app-navbar>
<app-breadcrumb></app-breadcrumb>

<div *ngIf="product.id == 0" class="loading">
    <mat-spinner></mat-spinner>
    <p>Cargando...</p>
</div>

<div *ngIf="product.id > 0" class="product-resume" fxLayoutAlign="center start">
    <div fxLayout="row" fxLayout.lt-md="column" fxFlex="1000px" fxFlex.xs="100%" fxFlex.sm="90%" fxFlex.md="90%" fxLayoutGap="80px" fxLayoutGap.xs="40px">

        <!-- Images Product -->
        <div fxFlex="50%">
            <div class="product-image-primary">
                <img *ngIf="imageShow != ''" [src]="imageShow" />
                <img *ngIf="imageShow == ''" src="/assets/img/products/sofa-1.png" alt="" />
            </div>
            <!-- Add class Active on Click Image Selected -->
            <div class="product-images">
                <drag-scroll *ngIf="productImages.length > 0" #imagesProduct drag-scroll-y-disabled="true" scrollbar-hidden="true">
                    <div (click)="clickPhoto(image)" class="image" *ngFor="let image of productImages" drag-scroll-item>
                        <img [src]="image" [alt]="" />
                    </div>
                </drag-scroll>
            </div>
        </div>

        <!-- Info Product -->
        <div fxFlex="50%">
            <div class="info-product">
                <div class="product-header">
                    <a *ngIf="product.brand" class="product-brand" [routerLink]="['/buscar-producto']" [queryParams]="{brand_id: product.brand.id}">
                        {{ product.brand.name }}
                    </a>
                    <h1 class="product-title">{{ product.title }}</h1>
                    <p class="product-description">{{ product.caption_short }}</p>
                </div>

                <div class="product-pricing">
                    <div class="price-label">
                        <span class="jam jam-credit-card-f"></span>
                        Precio Contado / Débito
                    </div>
                    
                    <div class="price-wrapper" *ngIf="getPrice() === getPriceTwo()">
                        <div class="current-price">{{ getPrice() | currency:'ARS':'symbol-narrow':'.0-0':'es-AR' }}</div>
                    </div>
                    
                    <div class="price-wrapper" *ngIf="getPrice() !== getPriceTwo()">
                        <div class="price-main">
                            <div class="current-price">{{ getPrice() | currency:'ARS':'symbol-narrow':'.0-0':'es-AR' }}</div>
                            <div class="price-savings">
                                <span class="original-price">{{ getPriceTwo() | currency:'ARS':'symbol-narrow':'.0-0':'es-AR' }}</span>
                                <span class="online-badge">
                                    <span class="jam jam-star-f"></span>
                                    Precio exclusivo web
                                </span>
                            </div>
                        </div>
                    </div>
                </div>


                <!-- Quantity Selector -->
                <div class="product-quantity">
                    <label>Cantidad</label>
                    <div class="quantity-selector">
                        <button class="quantity-btn" (click)="minQuantity()">
                            <span class="jam jam-minus"></span>
                        </button>
                        <input type="text" readonly [value]="quantity" />
                        <button class="quantity-btn" (click)="sumQuantity()">
                            <span class="jam jam-plus"></span>
                        </button>
                    </div>
                    <span class="stock-info">{{ getStock() }} disponibles</span>
                </div>

                <!-- Shipping Calculator -->
                <div class="shipping-section">
                    <label>Calcular envío</label>
                    <div class="shipping-input-wrapper">
                        <span class="jam jam-truck"></span>
                        <input 
                            type="text"
                            placeholder="Ingresá tu código postal" 
                            [(ngModel)]="zipCode"
                            maxlength="8"
                            (keypress)="onlyNumbers($event)"
                            (keyup.enter)="calculateShipping()">
                        <button 
                            class="btn-calculate"
                            (click)="calculateShipping()"
                            [disabled]="isCalculatingShipping">
                            <mat-spinner *ngIf="isCalculatingShipping" diameter="14"></mat-spinner>
                            <span *ngIf="!isCalculatingShipping">Calcular</span>
                        </button>
                    </div>
                    
                    <div *ngIf="shippingResult" class="shipping-info success">
                        <span class="jam jam-check"></span>
                        <div>
                            <strong>{{ shippingResult.total | currency:'ARS':'symbol-narrow':'.0-0':'es-AR' }}</strong>
                            <span class="delivery">Llega en {{ shippingResult.plazo_entrega }} {{ shippingResult.plazo_entrega == 1 ? 'día hábil' : 'días hábiles' }}</span>
                        </div>
                    </div>
                    
                    <div *ngIf="shippingError" class="shipping-info error">
                        <span class="jam jam-alert-triangle"></span>
                        <span>{{ shippingError }}</span>
                    </div>
                </div>

                <!-- Action Buttons -->
                <div class="product-actions">
                    <button *ngIf="getStock() > 0" class="btn-primary" (click)="addItemToCart()">
                        <span class="jam jam-shopping-cart"></span>
                        Agregar al carrito
                    </button>
                    <button *ngIf="getStock() == 0" class="btn-primary" disabled>
                        Sin Stock
                    </button>
                    <button class="btn-secondary" (click)="viewMountToCard()">
                        <span class="jam jam-credit-card"></span>
                        Ver cuotas
                    </button>
                </div>
            </div>
        </div>

    </div>
    <!-- fxLayout Row & 1000px -->
</div>
<!-- product-resume -->



<div *ngIf="product.id > 0" class="product-tabs">
    <div fxLayout="row" fxLayoutAlign="center start">
        <div fxFlex="1200px" fxFlex.xs="100%" fxFlex.lt-lg="90%">
            <div class="border-tab">
                <mat-tab-group>
                    <!-- Especificaciones -->
                    <mat-tab label="Especificaciones">
                        <div class="tab-content specifications-container">
                            <!-- Loop through sections (bultos/packages) -->
                            <div class="spec-section" *ngFor="let section of productSpecs; let isFirst = first">
                                <!-- Section header for bultos (UNIDAD INTERIOR, UNIDAD EXTERIOR, etc) -->
                                <div class="section-header" *ngIf="section.title">
                                    <div class="section-icon">
                                        <i [attr.data-feather]="section.icon"></i>
                                    </div>
                                    <h3 class="section-title">{{ section.title }}</h3>
                                </div>
                                
                                <!-- Specifications grid for this section -->
                                <div class="specifications-grid">
                                    <div class="spec-card" *ngFor="let spec of section.specs">
                                        <div class="spec-icon">
                                            <i [attr.data-feather]="spec.icon"></i>
                                        </div>
                                        <div class="spec-content">
                                            <div class="spec-label" *ngIf="spec.label">{{ spec.label }}</div>
                                            <div class="spec-value">{{ spec.value }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </mat-tab>


                    <mat-tab *ngIf="urlYoutube" label="Video">
                        <div class="tab-content">
                            <iframe class="iframe" width="560" height="315" [src]="urlYoutube" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in.picture" allowfullscreen></iframe>
                        </div>
                    </mat-tab>
                </mat-tab-group>
            </div>
        </div>
    </div>
</div>

<br/>
<!--<app-similar-products></app-similar-products>-->


<app-footer></app-footer>
